/* eslint-disable jsx-a11y/anchor-is-valid */
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import LazyLoad from 'react-lazyload';
import { useSelector } from 'react-redux';
function OldNews() {
  const [articles, setArticles] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimitPage] = useState(3);
  const { featuredArticles } = useSelector((state) => state.articles);

  const getArticlesHighlight = (page = 1, limit = 5) => {
    axios
      .get('/api/v1/article-page-custom', {
        params: {
          page: page,
          limit: limit,
        },
      })
      .then(({ data }) => {
        if (data.success) {
          setArticles([...articles, ...data.payload.articles]);
          if (data.payload.length === 0) {
            setCurrentPage(currentPage);
            return;
          }
          setCurrentPage(page);
          setLimitPage(limit);
        }
      });
  };
  useEffect(() => {
    getArticlesHighlight();
  }, []);

  return (
    <div className='recent-area pt-50 pb-50'>
      <div className='container'>
        <div className='row'>
          <div className='col-lg-8 col-md-12'>
            <div className='widget-header position-relative mb-30'>
              <h5 className='widget-title mb-30 text-uppercase color1 font-weight-ultra'>
                Các tin nổi bật khác
              </h5>
              <div className='letter-background'>C</div>
            </div>
            <div className='loop-list mt-80'>
              {articles.length > 0 &&
                articles.map(
                  (
                    {
                      short_description,
                      slug,
                      thumbnail,
                      title,
                      created_at,
                      name_category,
                      slug_category,
                      background_color_category,
                      is_video_news,
                    },
                    index
                  ) => {
                    return (
                      <LazyLoad height={350} key={index}>
                        <article className='row mb-50'>
                          <div className='col-md-6'>
                            <div className='post-thumb position-relative thumb-overlay mr-20'>
                              <div
                                className='img-hover-slide border-radius-5 position-relative'
                                style={{
                                  backgroundImage: `url(${thumbnail})`,
                                }}
                              >
                                <a
                                  className='img-link'
                                  href={`/${
                                    is_video_news === 1
                                      ? 'tin-video'
                                      : 'tin-tuc'
                                  }/${slug}`}
                                ></a>
                                {/* <span className='top-right-icon background8'>
                                <i className='mdi mdi-flash-on'></i>
                              </span> */}
                              </div>
                            </div>
                          </div>
                          <div className='col-md-6 align-center-vertical'>
                            <div className='post-content'>
                              <div className='entry-meta meta-0 font-small mb-15'>
                                <a href={`/tin-tuc/${slug_category}`}>
                                  <span
                                    style={{
                                      backgroundColor:
                                        background_color_category,
                                    }}
                                    className={`post-cat color-white`}
                                  >
                                    {name_category}
                                  </span>
                                </a>
                              </div>
                              <h4 className='post-title text-limit-3-row'>
                                <a
                                  href={`/${
                                    is_video_news === 1
                                      ? 'tin-video'
                                      : 'tin-tuc'
                                  }/${slug}`}
                                >
                                  {title}
                                </a>
                              </h4>
                              <div className='entry-meta meta-1 font-small color-grey mt-15 mb-15'>
                                <span className='post-on'>
                                  <i className='ti-marker-alt'></i>
                                  {created_at}
                                </span>
                                {/* <span className='time-reading'>
                                <i className='ti-timer'></i>10 mins read
                              </span> */}
                                {/* <span className='hit-count'> */}
                                {/* <i className='ti-bolt'></i> 159k Views */}
                                {/* </span> */}
                              </div>
                              <p className='font-medium text-limit-4-row'>
                                {short_description}
                              </p>
                              <a
                                className='readmore-btn font-small text-uppercase font-weight-ultra'
                                href={`/tin-tuc/${slug}`}
                              >
                                Xem chi tiết
                                <i className='ti-arrow-right ml-5'></i>
                              </a>
                            </div>
                          </div>
                        </article>
                      </LazyLoad>
                    );
                  }
                )}
            </div>
            <div className='pagination-area pt-30 text-center bt-1 border-color-1'>
              <div className='container'>
                <div className='row'>
                  <div className='col-xl-12'>
                    <div className='single-wrap d-flex justify-content-center'>
                      <button
                        className='btn pt-20 pb-20 pl-20 pr-20 font-weight-bold'
                        style={{ minWidth: 'auto' }}
                        onClick={() => {
                          let page = currentPage + 1;
                          getArticlesHighlight(page, 5);
                        }}
                      >
                        Xem thêm
                      </button>
                      {/* <nav aria-label='Page navigation example'>
                        <ul className='pagination justify-content-start'>
                          <li className='page-item'>
                            <a
                              className='page-link'
                              href='#'
                              onClick={(e) => {
                                e.preventDefault();
                                if (currentPage - 1 < 1) {
                                  return;
                                }
                                setCurrentPage(currentPage - 1);
                              }}
                            >
                              <i className='flaticon-left'></i>{' '}
                            </a>
                          </li>
                          {Array.from(
                            Array(Math.round(totalPage / 3)).keys()
                          ).map((value) => (
                            <li
                              className={`page-item ${
                                currentPage === value + 1 ? 'active' : ''
                              }`}
                              key={value}
                            >
                              <a
                                className='page-link'
                                href='#'
                                onClick={(e) => {
                                  e.preventDefault();
                                  setCurrentPage(value + 1);
                                }}
                              >
                                {value + 1}
                              </a>
                            </li>
                          ))}

                          <li className='page-item'>
                            <a
                              className='page-link'
                              href='#'
                              onClick={(e) => {
                                e.preventDefault();
                                if (
                                  currentPage + 1 >
                                  Math.round(totalPage / 3)
                                ) {
                                  return;
                                }
                                setCurrentPage(currentPage + 1);
                              }}
                            >
                              <i className='flaticon-right'></i>{' '}
                            </a>
                          </li>
                        </ul>
                      </nav> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='col-lg-4 col-md-12'>
            <div className='widget-area'>
              <div className='sidebar-widget widget-social-network mb-30'>
                <div className='widget-header position-relative mb-30'>
                  <h5 className='widget-title mt-5 mb-30'>
                    Theo dõi chúng tôi
                  </h5>
                </div>
                <div className='social-network'>
                  <div className='follow-us d-flex align-items-center'>
                    <a
                      className='follow-us-facebook clearfix mr-5 mb-10'
                      href='https://www.facebook.com/SMEdx.vn'
                      target='_blank'
                    >
                      <div className='social-icon'>
                        <i className='ti-facebook mr-5 v-align-space'></i>
                        <i className='ti-facebook mr-5 v-align-space nth-2'></i>
                      </div>
                      <span className='social-name'>Facebook</span>
                      {/* <span className='social-count counter-number'>65</span>
                      <span className='social-count'>K</span> */}
                    </a>
                    {/* <a
                      className='follow-us-twitter clearfix ml-5 mb-10'
                      href='#'
                      target='_blank'
                    >
                      <div className='social-icon'>
                        <i className='ti-twitter-alt mr-5 v-align-space'></i>
                        <i className='ti-twitter-alt mr-5 v-align-space nth-2'></i>
                      </div>
                      <span className='social-name'>Twitter</span>
                      <span className='social-count counter-number'>75</span>
                      <span className='social-count'>K</span>
                    </a> */}
                  </div>
                  {/* <div className='follow-us d-flex align-items-center'>
                    <a
                      className='follow-us-instagram clearfix mr-5'
                      href='#'
                      target='_blank'
                    >
                      <div className='social-icon'>
                        <i className='ti-instagram mr-5 v-align-space'></i>
                        <i className='ti-instagram mr-5 v-align-space nth-2'></i>
                      </div>
                      <span className='social-name'>Instagram</span>
                      <span className='social-count counter-number'>32</span>
                      <span className='social-count'>K</span>
                    </a>
                    <a
                      className='follow-us-youtube clearfix ml-5'
                      href='#'
                      target='_blank'
                    >
                      <div className='social-icon'>
                        <i className='ti-youtube mr-5 v-align-space'></i>
                        <i className='ti-youtube mr-5 v-align-space nth-2'></i>
                      </div>
                      <span className='social-name'>Youtube</span>
                      <span className='social-count counter-number'>28</span>
                      <span className='social-count'>K</span>
                    </a>
                  </div> */}
                </div>
              </div>
              <div className='sidebar-widget widget-taber mb-30'>
                <div className='widget-taber-content background-white pt-30 pb-30 pl-30 pr-30 border-radius-5'>
                  <nav className='tab-nav float-none mb-20'>
                    <div className='nav nav-tabs' id='nav-tab' role='tablist'>
                      <a
                        className='nav-item nav-link active'
                        id='nav-trending-tab'
                        data-toggle='tab'
                        href='#nav-trending'
                        role='tab'
                        aria-controls='nav-trending'
                        aria-selected='false'
                      >
                        Tài liệu hướng dẫn
                      </a>
                      <a
                        className='nav-item nav-link'
                        id='nav-popular-tab'
                        data-toggle='tab'
                        href='#nav-popular'
                        role='tab'
                        aria-controls='nav-popular'
                        aria-selected='true'
                      >
                        Phổ biến
                      </a>
                      {/* <a
                        className='nav-item nav-link'
                        id='nav-comment-tab'
                        data-toggle='tab'
                        href='#nav-comment'
                        role='tab'
                        aria-controls='nav-comment'
                        aria-selected='false'
                      >
                        Comments
                      </a> */}
                    </div>
                  </nav>
                  <div className='tab-content'>
                    <div
                      className='tab-pane fade'
                      id='nav-popular'
                      role='tabpanel'
                      aria-labelledby='nav-popular-tab'
                    >
                      <div className='post-block-list post-module-1'>
                        <ul className='list-post'>
                          {featuredArticles.map(
                            (
                              {
                                title,
                                slug,
                                thumbnail,
                                name_category,
                                created_at,
                                slug_category,
                                background_color_category,
                              },
                              index
                            ) => (
                              <li className='mb-30' key={index}>
                                <div className='d-flex'>
                                  <div className='post-thumb d-flex mr-15 border-radius-5 img-hover-scale'>
                                    <a href={'/tin-tuc/' + slug}>
                                      <img src={thumbnail} alt='' />
                                    </a>
                                  </div>
                                  <div className='post-content media-body'>
                                    <div className='entry-meta meta-0 mb-10'>
                                      <a href={'/tin-tuc/' + slug_category}>
                                        <span
                                          style={{
                                            backgroundColor:
                                              background_color_category,
                                          }}
                                          className={`post-in color-white font-small`}
                                        >
                                          {name_category}
                                        </span>
                                      </a>
                                    </div>
                                    <a href={'/tin-tuc/' + slug}>
                                      <h6 className='post-title mb-10 text-limit-2-row'>
                                        {title}
                                      </h6>
                                      <div className='entry-meta meta-1 font-x-small color-grey'>
                                        <span className='post-on'>
                                          {created_at}
                                        </span>
                                        {/* <span className='hit-count has-dot'>
                                        26k Views
                                      </span> */}
                                      </div>
                                    </a>
                                  </div>
                                </div>
                              </li>
                            )
                          )}
                        </ul>
                      </div>
                    </div>
                    <div
                      className='tab-pane active show'
                      id='nav-trending'
                      role='tabpanel'
                      aria-labelledby='nav-trending-tab'
                    >
                      <div className='post-block-list post-module-1'>
                        <ul className='list-post'>
                          <li className='mb-30'>
                            <div className='d-flex'>
                              <div className='post-thumb d-flex mr-15 border-radius-5 img-hover-scale'>
                                <a
                                  className='color-black'
                                  href='/huong-dan-su-dung'
                                >
                                  <img src='/assets/img/huong_dan.png' alt='' />
                                </a>
                              </div>
                              <div className='post-content media-body'>
                                <h6 className='post-title mb-10 text-limit-2-row'>
                                  <a
                                    className='color-black'
                                    href='/huong-dan-su-dung'
                                  >
                                    Tài liệu tham khảo
                                  </a>
                                </h6>
                                <div className='entry-meta meta-1 font-x-small color-grey'>
                                  <span className='post-on'>26/3/2021</span>
                                  {/* <span className='hit-count has-dot'>26k Views</span> */}
                                </div>
                              </div>
                            </div>
                          </li>
                          <li className='mb-30'>
                            <div className='d-flex'>
                              <div className='post-thumb d-flex mr-15 border-radius-5 img-hover-scale'>
                                <a
                                  className='color-black'
                                  href='https://smedx.vn/quyet-dinh-so-377-cua-bo-truong-bo-thong-tin-truyen-thong'
                                >
                                  <img
                                    src='data:image/jpeg;base64,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'
                                    alt=''
                                  />
                                </a>
                              </div>
                              <div className='post-content media-body'>
                                <h6 className='post-title mb-10 text-limit-2-row'>
                                  <a
                                    className='color-black'
                                    href='https://smedx.vn/quyet-dinh-so-377-cua-bo-truong-bo-thong-tin-truyen-thong'
                                  >
                                    Quyết định số 377/QĐ-BTTTT
                                  </a>
                                </h6>
                                <div className='entry-meta meta-1 font-x-small color-grey'>
                                  <span className='post-on'>26/3/2021</span>
                                  {/* <span className='hit-count has-dot'>26k Views</span> */}
                                </div>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* <div className='sidebar-widget widget-ads mb-30 text-center'>
                <a
                  href='https://vimeo.com/333834999'
                  className='play-video'
                  data-animate='zoomIn'
                  data-duration='1.5s'
                  data-delay='0.1s'
                >
                  <img
                    className='d-inline-block'
                    src='http://via.placeholder.com/432x200'
                    alt=''
                  />
                </a>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default OldNews;
